<template>
    <v-list-item 
        :key="model.name" 
        @click.stop="selectNode" 
        @dblclick.stop="goNode" 
        v-bind:class="{'project-tree-item':true, 'selected-item': ( globalState.selectedID === modelID ), back: model.back, gray: ( !model.permissions.can_i_read )}">
        <v-list-item-action>
            <v-icon v-if='model.back' large>keyboard_arrow_down</v-icon>
            <v-img v-else :src="imgSrc" max-width="24"></v-img>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title style="display: flex;align-items: center;gap:8px">
                <span>
                    {{modelName}}
                </span>
                <v-tooltip top open-delay=700>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on" class="inlineDetails">
                            <v-icon v-if="model.is_root_of_subdomain" color="green">domain</v-icon>
                            V:<b>{{model.version_id}}</b> {{chNumber}} / {{docNumber}}
                        </span>
                    </template>
                    <div v-show="model.parent">
                        <div v-for="( node, index ) in nodeInfo">{{node}}</div>
                    </div>
                </v-tooltip>
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    
</template>

<script>

export default {
  name: 'NodeListRow', 
  props: {
      model: {},
      versionList: []
  },
  data () {
    return {
        globalState: this.$globalStore.state,
        showVerMenu: false,
        subG: false
    };
  },
  computed: {
    chNumber()
    {
        return this.model.children_count ? this.model.children_count - this.docNumber : 0;
    },
    docNumber()
    {
        return this.model.data_contents ? this.model.data_contents.length : 0;
    },
    nodeInfo()
    {
        let info = [];
        
        let docNum = this.docNumber;
        let chNum = this.chNumber;

        info.push( 'Version: ' + this.model.version_id );
        if( chNum > 0 )
            info.push( 'Children: ' + chNum );
        else
            info.push( 'Children: none' );
        
        if( docNum > 0 )
            info.push( 'Documents: ' + docNum );
        else
            info.push( 'Documents: none' );
        
        if( this.model.is_root_of_subdomain )
            info.push( 'Root of subdomain' );
        else if( this.model.is_part_of_subdomain )
            info.push( 'Part of subdomain' );
        
        return info;
    },
    imgSrc()
    { 
        return this.$utils.getImage( this.model.element_type, this.model.quantity );
    },
    modelID()
    {
        if( this.model.message_id )
            return this.model.message_id; 
        else if( this.model.occurrence && !this.model.back )
            return this.model.occurrence.instance_id;
        else
            return this.model.instance_id;
    },
    modelName()
    {
        let attr = this.$globalStore.state.renameNodeAttr[ this.model.instance_id ];
        if( !attr )
            attr = this.$globalStore.state.curRenameNodeAttr;
        
        if( !attr )
            attr = 'NameInList';
        
        if( attr )
        {
            for( let i = 0; i < this.model.properties.length; i++ )
            {
                let prop = this.model.properties[ i ];
                if( this.$utils.clearType( prop.name ) === attr )
                    return prop.val;
            }
        }
        
        if( this.model.occurrence )
            return this.model.name + ' / ' + this.model.occurrence.name;

        return this.model.name;        
    },
    modelHasChildren()
    {
        return !this.model.back;
    }
  },
  components: {
       
  },
  methods: 
  {
      openHelp( link )
      {
          this.$utils.openHelp( link );
      },

      procFunc: function( cmd )
      {
          this.showMenu = false;      
          this.$emit( 'procRowMenuCmd', [ cmd , this.model ] );       
      },      
      selectNode: function()
      {
        if( this.model.elemID )
        {
            this.$globalStore.setSelectedID( this.model.elemID );  
            this.$eventBus.$emit( 'updateProd', this.model );
        }
        else
        {
            this.$globalStore.setSelectedID( this.modelID );  
            this.$eventBus.$emit( 'showSelProps', this.model );
        }
      },
      goNode: function()
      {
        this.$globalStore.setSelectedID( this.modelID );
        if( this.modelHasChildren )
            this.$eventBus.$emit( 'goInNode', this.model );
        else if( this.model.back )
            this.$eventBus.$emit( 'goOutNode', this.model );
        this.$globalStore.setSelectedID( this.modelID );
      }
  },
}
</script>

<style scoped>
    .selected-item
    {
        background-color: var(--brand-main-color) !important;
        color: white !important;
    }

    .project-tree-item.v-list-item.back >>> .v-list-item__title{
        font-size: 18px !important;
        font-weight: 800;
        color: #666 !important;
    }
    .project-tree-item.v-list-item.selected-item.back >>> .v-list-item__title{
        color: #EEE !important;
    }
    .project-tree-item.v-list-item.back >>> .v-btn .v-icon{
        color: #666 !important;
    }

    .project-tree-item.v-list-item >>> .v-btn .v-icon{
        color: #DDD;
    }
    .project-tree-item.v-list-item:hover >>> .v-btn .v-icon{
        color: #666 !important;
    }

    .project-tree-item.v-list-item.selected-item >>> .v-btn .v-icon,
    .project-tree-item.v-list-item.selected-item.back >>> .v-icon
    {
        color: #EEE !important;
    }
    .project-tree-item.v-list-item:hover.selected-item >>> .v-icon{
        color: #fff !important;
    }

    .project-tree-item .v-list-item__action:last-of-type:not(:only-child),
    .project-tree-item .v-list-item__avatar:last-of-type:not(:only-child),
    .project-tree-item .v-list-item__icon:last-of-type:not(:only-child){
        margin-left: 2px !important;
    }
    .inlineDetails{
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        padding: 2px 5px 0;
        height: 21px;
        color: #AAA;
        font-size: 75%;
        background-color: #FFF;
        position: sticky;
        z-index: 2;
        right: 0;
        display: inline-flex;
        align-items: center;
        line-height: initial;
        white-space: nowrap;
    }

    .selected-item .inlineDetails{
        background-color: var(--brand-main-color) !important;
        color: #dddddd;
        border: 1px solid #eeeeee36;
    }
    .inlineDetails >>> b{
        margin-right: 8px;
    }

    .inlineDetails >>> .v-icon {
        top: -1px;
        height: 15px;
        width: 17px;
        font-size: 13px;
    }
    .v-list-item >>> .v-list-item__content{
        padding: 0 !important;
    }
    .v-list-item >>> .v-list-item__title{
        line-height: 1.5em;
    }
</style>
